export default __webpack_public_path__ + "static/media/Logo.eeaa7a8e.svg";